import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchUserEngagementReport = createAsyncThunk(
  'analytics/fetchUserEngagementReport',
  async ({ startDate, endDate }) => {
    const response = await api.get('/analytics/user-engagement', { params: { startDate, endDate } });
    return response.data.data;
  }
);

export const fetchIssueResolutionRates = createAsyncThunk(
  'analytics/fetchIssueResolutionRates',
  async ({ startDate, endDate }) => {
    const response = await api.get('/analytics/issue-resolution-rates', { params: { startDate, endDate } });
    return response.data.data;
  }
);

export const fetchPostActivityReport = createAsyncThunk(
  'analytics/fetchPostActivityReport',
  async ({ startDate, endDate }) => {
    const response = await api.get('/analytics/post-activity', { params: { startDate, endDate } });
    return response.data.data;
  }
);

const initialState = {
  userEngagement: null,
  issueResolutionRates: null,
  postActivity: null,
  status: 'idle',
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserEngagementReport.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserEngagementReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userEngagement = action.payload;
      })
      .addCase(fetchUserEngagementReport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      })
      .addCase(fetchIssueResolutionRates.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchIssueResolutionRates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.issueResolutionRates = action.payload;
      })
      .addCase(fetchIssueResolutionRates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      })
      .addCase(fetchPostActivityReport.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPostActivityReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.postActivity = action.payload;
      })
      .addCase(fetchPostActivityReport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      });
  },
});

export default analyticsSlice.reducer;
